export default __webpack_public_path__ + "35b5d9cf9232cbd88863ed7c466a08cb.jpg";